import { createFileRoute } from '@tanstack/react-router';
import { GeneralSettingsPage } from '@/features/admin/system-settings';

export const Route = createFileRoute('/admin/system-settings/general/')({
  component: AdminGeneralSettingsRoute,
});

function AdminGeneralSettingsRoute() {
  return <GeneralSettingsPage />;
}
